import { css } from "styled-components";
/** @class ProgressStepperCurrentLabelMixin */

/** @method */

export var ProgressStepperCurrentLabelMixin = /*#__PURE__*/css(["margin-top:0;"]);